import {RACING_MARKETS} from '../modules/racing/constants/identifiers';
import {FOOTBALL_MARKETS} from '../modules/football/constants/identifiers';
import {BASKETBALL_MARKETS} from "../modules/basketball/constants/identifiers";
import {AMERICAN_FOOTBALL_MARKETS} from "../modules/americanFootball/constants/identifiers";

export function getRacingMarketNameByCode(code) {
    let market = RACING_MARKETS.find((mkt) => mkt.code === code);

    if (market) {
        return market.name;
    }
}

export function getFootballMarketNameByCode(code) {
    let market = FOOTBALL_MARKETS.find((mkt) => mkt.code === code);

    if (market) {
        return market.name;
    }
}

export function getBasketballMarketNameByCode(code) {
    let market = BASKETBALL_MARKETS.find((mkt) => mkt.code === code);

    if (market) {
        return market.name;
    }
}

export function getAFMarketNameByCode(code) {
    let market = AMERICAN_FOOTBALL_MARKETS.find((mkt) => mkt.code === code);

    if (market) {
        return market.name;
    }
}



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/helpers/marketHelpers.js